<div class="container-fluid">
    <app-header titleText="Dealer Engagement" i18n-titleText>
        <div button class="float-right">
            <div *ngIf="!isRequesting">
                <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
                <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
            </div>
            <app-spinner [isRunning]="isRequesting"></app-spinner>
        </div>
    </app-header>

    <div *ngIf="report == null">
        <h5 i18n>Please provide report criteria</h5>
    </div>
    <div *ngIf="report">
        <div class="row header-text">

            <div class="col-md-4">
            </div>
            <div class="col-md-6 filter-zone">
                <p>
                    <span i18n>REPORT DEFINED:</span><br />
                    <ng-template [ngIf]="parameters.startDate != null">
                        <span i18n>Date Range:</span> {{parameters.startDate | date: 'M/d/yyyy'}} - {{parameters.endDate | date: 'M/d/yyyy'}}<br />
                    </ng-template>
                    <ng-template [ngIf]="parameters.startDate == null">
                        <span i18n>Date Range:</span>All Years<br />
                    </ng-template>

                    <ng-template [ngIf]="dealer"><span i18n>Dealer:</span> {{dealer.dealer_BusinessName}}<br /></ng-template>
                </p>
            </div>
        </div>

        <div class="content">
            <div class="quote-month-summary">
                <h2 i18n>Activity</h2>
                <div>
                    <table class="table table-bidit">
                        <thead>
                          <tr>
                            <th i18n>Dealer</th>
                            <th i18n>Region</th>
                            <th i18n>Customer Number</th>
                            <th i18n>SalesPerson</th>
                            <th i18n>Created</th>
                            <th i18n>Logins</th>
                            <th i18n>New Customers</th>
                            <th i18n>New Leads</th>
                            <th i18n>New Quotes</th>
                            <th i18n>Lost Quotes</th>
                            <th i18n>Converted Jobs</th>
                            <th i18n>New Work Orders</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let dealer of report">
                            <td>{{dealer.dealer_BusinessName}}</td>
                            <td>{{dealer.region_Desc}}</td>
                            <td>{{dealer.customerNumber}}</td>
                            <td>{{dealer.salesperson}}</td>
                            <td>{{dealer.dealer_Created | date : 'M/d/yyyy'}}</td>
                            <td>{{dealer.logins}}</td>
                            <td>{{dealer.customers}}</td>
                            <td>{{dealer.leads}}</td>
                            <td>{{dealer.quotes}}</td>
                            <td>{{dealer.quotesLost}}</td>
                            <td>{{dealer.jobs}}</td>
                            <td>{{dealer.workOrders}}</td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
